import React from "react";
import HealthDashboard from "@/components/integrations/HealthDashboard";
import IntegrationErrorBoundary from "@/components/common/ErrorBoundary";
import GlobalFilter from "@/components/common/GlobalFilter";
import { useGlobalFilter } from "@/features/filters/filter.context";

const HealthDashboardPage: React.FC = () => {
  const { filter: filterState } = useGlobalFilter();

  return (
    <IntegrationErrorBoundary
      integrationType="general"
      integrationId="health-dashboard"
    >
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">
              Dashboard de Saúde
            </h1>
            <p className="text-muted-foreground">
              Monitoramento centralizado da saúde de todas as integrações
            </p>
          </div>
        </div>

        <GlobalFilter />

        <HealthDashboard />
      </div>
    </IntegrationErrorBoundary>
  );
};

export default HealthDashboardPage;
